import { Component } from '@angular/core';
import { AuthenticationFeatureService } from '../../../features/authentication-feature/authentication-feature.service';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  imports: [MatButton],
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.css',
})
export class UnauthorizedComponent {
  constructor(private _authFeature: AuthenticationFeatureService) {}

  logout() {
    this._authFeature.logout();
  }
}
